// import ProjectMgnt from "../BlurImageBackground/ProjectManagement";
// import WeareHere from "../FirstBanner/Welcometobrick";
// import Projectprogress from "../LeftImageRightText/ProjectProgress";
import TextonImageBrick from "../Brick/TextonImageBrick/TextonImage";
import { useState, useMemo } from "react";

import Partners from "./Partners/Partners";


function HomePage() {
  return (
    <div class="container-fluid">
     <TextonImageBrick />
     <Partners/>
     {/* <Projectprogress />
     <ProjectMgnt/> */}
     {/* <CoreValues/> */}
     {/* <WeareHere pagename="Home"/> */}
    </div>
  );
}

export default HomePage;

